export const changePlaceholderText = () => {
  window.onload = () => {
    var emailInput = document.querySelector(".landing-page__newsletter-form .klaviyo-form input[type='email']");
    if (emailInput) {
      emailInput.placeholder = 'Email address';
    }
  };
};
